"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCommonModule = createCommonModule;
exports.state = void 0;

var _getters = require("./getters");

var _actions = require("./actions");

var _mutations = require("./mutations");

var _helper = require("@/services/helper/helper.service");

var helper = new _helper.Helper();
var state = {
  language: helper.getCookie(process.env.VUE_APP_LOCALE_COOKIE) || process.env.VUE_APP_LOCALE,
  breadcrumbList: [],
  loading: true,
  isDarkTheme: null,
  isFullscreen: false,
  isOrderFullscreen: false,
  isMobile: false,
  mainContainerHeight: 0,
  dashboardVehicles: [],
  isTab: false,
  drivers: [],
  projectCodes: [],
  customers: [],
  trucks: [],
  socketId: null
};
exports.state = state;
var namespaced = true;
var CommonModule = {
  namespaced: namespaced,
  state: state,
  getters: _getters.getters,
  actions: _actions.actions,
  mutations: _mutations.mutations
};

function createCommonModule() {
  return CommonModule;
}